export default {
  data () {
    return {
      width: 0
    }
  },

  computed: {
    isMediumScreen () {
      return this.width > 768
    }
  },

  mounted () {
    this.width = document.documentElement.clientWidth
    window.addEventListener('resize', this.getDimensions)
  },
  unmounted () {
    window.removeEventListener('resize', this.getDimensions)
  },

  methods: {
    getDimensions () {
      this.width = document.documentElement.clientWidth
    }
  }
}
